export var GET_ALL_CANDIDATES = '[Candidates] Get All';
export var GET_ALL_CANDIDATES_SUCCESS = '[Candidates] Get All Success';
export var GET_ALL_CANDIDATES_ERROR = '[Candidates] Get All Error';
export var GET_CANDIDATE = '[Candidates] Get Candidate';
export var GET_CANDIDATE_SUCCESS = '[Candidates] Get Candidate Success';
export var GET_CANDIDATE_ERROR = '[Candidates] Get Candidate Error';
export var DELETE_CANDIDATE = '[Candidates] Delete Candidate';
export var DELETE_CANDIDATE_SUCCESS = '[Candidates] Delete Candidate Success';
export var DELETE_CANDIDATE_ERROR = '[Candidates] Delete Candidate Error';
var GetAllCandidates = /** @class */ (function () {
    function GetAllCandidates() {
        this.type = GET_ALL_CANDIDATES;
    }
    return GetAllCandidates;
}());
export { GetAllCandidates };
var GetAllCandidatesSuccess = /** @class */ (function () {
    function GetAllCandidatesSuccess(payload) {
        this.payload = payload;
        this.type = GET_ALL_CANDIDATES_SUCCESS;
    }
    return GetAllCandidatesSuccess;
}());
export { GetAllCandidatesSuccess };
var GetAllCandidatesError = /** @class */ (function () {
    function GetAllCandidatesError(payload) {
        this.payload = payload;
        this.type = GET_ALL_CANDIDATES_ERROR;
    }
    return GetAllCandidatesError;
}());
export { GetAllCandidatesError };
var GetCandidate = /** @class */ (function () {
    function GetCandidate(payload) {
        this.payload = payload;
        this.type = GET_CANDIDATE;
    }
    return GetCandidate;
}());
export { GetCandidate };
var GetCandidateSuccess = /** @class */ (function () {
    function GetCandidateSuccess(payload) {
        this.payload = payload;
        this.type = GET_CANDIDATE_SUCCESS;
    }
    return GetCandidateSuccess;
}());
export { GetCandidateSuccess };
var GetCandidateError = /** @class */ (function () {
    function GetCandidateError(payload) {
        this.payload = payload;
        this.type = GET_CANDIDATE_ERROR;
    }
    return GetCandidateError;
}());
export { GetCandidateError };
var DeleteCandidate = /** @class */ (function () {
    function DeleteCandidate(payload) {
        this.payload = payload;
        this.type = DELETE_CANDIDATE;
    }
    return DeleteCandidate;
}());
export { DeleteCandidate };
var DeleteCandidateSuccess = /** @class */ (function () {
    function DeleteCandidateSuccess() {
        this.type = DELETE_CANDIDATE_SUCCESS;
    }
    return DeleteCandidateSuccess;
}());
export { DeleteCandidateSuccess };
var DeleteCandidateError = /** @class */ (function () {
    function DeleteCandidateError(payload) {
        this.payload = payload;
        this.type = DELETE_CANDIDATE_ERROR;
    }
    return DeleteCandidateError;
}());
export { DeleteCandidateError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/candidates/store/actions/candidate.action.ts.pre-build-optimizer.js